// Recovered compiled webpack factory 8453. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { v: () => s });
  var n = i(16105);
  class s {
    constructor() {
      this.subscriptions = [];
    }
    add(t) {
      return ((0, n.Kq)(this.subscriptions, t), () => (0, n.Ai)(this.subscriptions, t));
    }
    notify(t, e, i) {
      let n = this.subscriptions.length;
      if (n)
        if (1 === n) this.subscriptions[0](t, e, i);
        else
          for (let s = 0; s < n; s++) {
            let n = this.subscriptions[s];
            n && n(t, e, i);
          }
    }
    getSize() {
      return this.subscriptions.length;
    }
    clear() {
      this.subscriptions.length = 0;
    }
  }
}
